/**
 * @description: Convert hours to minutes
 */
export default function genDurationFromHours(hours: string | number): number {
  return parseInt(String(hours)) * 60;
}
